export class ScheduleTemplate {
    constructor(name, pause_preferences, room_preferences) {
        this.name = name;
        this.pause_preferences = pause_preferences;
        this.room_preferences = room_preferences;
    }
    static load(data) {
        // @ts-ignore
        return new ScheduleTemplate(data.name, data.pause_preferences, data.room_preferences);
    }
    static empty() {
        return new ScheduleTemplate('', [], {});
    }
}
